<template>
  <header>
    <h2>{{ headline }}</h2>
    <slot />
  </header>
</template>

<style lang="stylus" scoped>
  header
    background var(--color-light-background)
    border-bottom 1px solid var(--color-border)
    display flex
    padding var(--gap) calc(var(--gap) * 2)
    justify-content space-between
    align-items center

    margin-bottom calc(var(--gap) * 2)

    h2
      margin 0
      padding 0
</style>

<script>
  export default {
    name: 'EmHeader',
    props: {
      headline: {
        type: String,
        required: true
      }
    }
  }
</script>
